import React from 'react';
import { Toolbar, Typography, Box } from '@mui/material';

interface PanelHeaderProps {
  title: React.ReactNode;
  children?: React.ReactNode;
}

export const PanelHeader: React.FC<PanelHeaderProps> = ({ title, children }) => {
  return (
    <Toolbar
      variant="regular"
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        borderRadius: '8px 8px 0 0 '
      }}
    >
      <Typography variant="h3" sx={{ flexGrow: 1 }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {children}
      </Box>
    </Toolbar>
  );
};